import React from "react";
import { ARIAKE, IMG } from "../lib/data";
import { MapPin } from "lucide-react";

export default function Ubicacion() {
  return (
    <section
      id="ubicacion"
      data-testid="ubicacion-section"
      className="bg-[hsl(var(--hh-bone))] py-20 md:py-28 lg:py-32 border-t border-black/5"
    >
      <div className="container-hh">
        <div className="reveal max-w-2xl">
          <div className="flex items-center gap-3 sm:gap-4 mb-5 sm:mb-6">
            <span className="accent-line" />
            <span className="overline text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.65rem" }}>
              Ubicación
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            Tumbaco, sector{" "}
            <em style={{ fontStyle: "italic", color: "hsl(var(--hh-moss))" }}>
              Hilacril.
            </em>
          </h2>
          <p className="mt-5 text-[hsl(0,0%,32%)] text-sm md:text-base max-w-xl leading-relaxed">
            En un valle privilegiado, junto al cañón del río Chiche.
          </p>
        </div>

        <div className="mt-12 md:mt-14 bg-white border border-black/10 overflow-hidden">
          <div className="relative w-full aspect-[16/10] md:aspect-[21/9] bg-white">
            <img
              src={IMG.ariake.implantacion}
              alt="Ariake — implantación general del conjunto"
              className="absolute inset-0 h-full w-full object-contain bg-white"
              loading="lazy"
            />
          </div>
          <div className="p-5 md:p-7 flex items-center gap-3 border-t border-black/10">
            <MapPin size={16} className="text-[hsl(var(--hh-moss))]" />
            <div>
              <div className="overline text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.58rem" }}>
                {ARIAKE.location.label}
              </div>
              <div className="text-sm md:text-base text-[hsl(0,0%,22%)]">
                {ARIAKE.location.address}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
